export default "__VITE_ASSET__b795e77d__"